import React, { useId } from 'react'
import PropTypes from 'prop-types'

const CloudNotificationIcon = React.forwardRef(function CloudNotificationIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M20 11C22.2091 11 24 9.20914 24 7C24 4.79086 22.2091 3 20 3C17.7909 3 16 4.79086 16 7C16 9.20914 17.7909 11 20 11Z"></path>
      <path d="M20.84 12.93C21.55 13.57 22 14.48 22 15.5C22 17.43 20.43 19 18.5 19H5.5C3.57 19 2 17.43 2 15.5C2 13.73 3.34 12.24 5.11 12.04L6 11.89V11C6 7.69 8.69 5 12 5C12.78 5 13.53 5.16 14.21 5.44C14.39 4.78 14.67 4.16 15.05 3.61C14.11 3.22 13.08 3 12 3C7.87 3 4.46 6.15 4.04 10.22C1.69 10.86 0 13 0 15.5C0 18.53 2.47 21 5.5 21H18.5C21.53 21 24 18.53 24 15.5C24 14.28 23.6 13.16 22.91 12.24C22.28 12.59 21.58 12.83 20.84 12.93Z"></path>
    </svg>
  )
})

CloudNotificationIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

CloudNotificationIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default CloudNotificationIcon
